{
  "loading": "Laster inn ...",
  "loadingMore": "Laster inn flere ..."
}
